import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import messages from 'vee-validate/dist/locale/fr'

var userLang = navigator.language || navigator.userLanguage;
userLang = userLang.toLowerCase();

if(userLang == 'fr_fr'){
    Validator.localize('fr_fr', messages);
}

Vue.use(VeeValidate, { inject: false});

export default VeeValidate;


// WEBPACK FOOTER //
// ./src/validator/index.js